import apis from "../../utils/apis";

export const FETCH_APP_CONFIG_REQUEST = "FETCH_APP_CONFIG_REQUEST";
export const FETCH_APP_CONFIG_SUCCESS = "FETCH_APP_CONFIG_SUCCESS";
export const FETCH_APP_CONFIG_FAILURE = "FETCH_APP_CONFIG_FAILURE";

export const fetchAppConfigRequest = () => ({ type: FETCH_APP_CONFIG_REQUEST });

export const fetchAppConfigSuccess = (config) => ({
  type: FETCH_APP_CONFIG_SUCCESS,
  payload: config,
});

export const fetchAppConfigFailure = (error) => ({
  type: FETCH_APP_CONFIG_FAILURE,
  payload: error,
});

export const fetchAppConfig = () => async (dispatch, getState) => {
  const { footerLinks } = getState()?.appConfig || {};
  if (footerLinks?.length > 0) {
    return;
  }

  dispatch(fetchAppConfigRequest());
  try {
    const response = await apis.GET({ endpoint: "/get-app-configuration" });
    const footerLinks = Array.isArray(response?.data?.footerLinks)
      ? response.data.footerLinks
      : [];
    dispatch(fetchAppConfigSuccess({ footerLinks }));
  } catch (error) {
    console.error("Failed to fetch app configuration:", error);
    dispatch(fetchAppConfigFailure(error?.message || "Failed to fetch"));
  }
};
